import React from 'react'
import ReactDOM from 'react-dom'
import { ChainId, Config, DAppProvider, Mainnet } from '@usedapp/core'
import { App } from './App'
import 'bootstrap/dist/css/bootstrap.min.css';
import {store} from './store'
import { Provider } from 'react-redux'
import { getDefaultProvider } from 'ethers'


  // firebase analytics

  // Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
  // TODO: Add SDKs for Firebase products that you want to use
  // https://firebase.google.com/docs/web/setup#available-libraries

  // Your web app's Firebase configuration
  // For Firebase JS SDK v7.20.0 and later, measurementId is optional
  const firebaseConfig = {
    apiKey: "AIzaSyAVZCT-UGca34V87abjXpkehgILkuKpoCE",
    authDomain: "nodeview-1cb8a.firebaseapp.com",
    projectId: "nodeview-1cb8a",
    storageBucket: "nodeview-1cb8a.appspot.com",
    messagingSenderId: "628235860260",
    appId: "1:628235860260:web:27a5404a4bc05b60089bb1",
    measurementId: "G-QGVG4MC88N"
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);



const config: Config = {
  readOnlyChainId: Mainnet.chainId,
  readOnlyUrls: {
    [Mainnet.chainId]: getDefaultProvider('mainnet'),
  },
}

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
    <DAppProvider config={config}>
      <App />
    </DAppProvider>
    </Provider>,
  </React.StrictMode>,
  document.getElementById('root')
)
